module.exports = __webpack_public_path__ + "img/Flag_of_Luxembourg.4e06269e.svg";